// extracted by mini-css-extract-plugin
export default {"header":"Header_header__jWCji","hamburger":"Header_hamburger__ScH2A","title":"Header_title__6QTfu","searchBtn":"Header_searchBtn__tFyQD"};